import { createAction } from 'redux-actions';
export const ADD_NEW_FLIGHT = 'ADD_NEW_FLIGHT';
export const CLEAR_FLIGHT = 'CLEAR_FLIGHT';
export const addFare = createAction(ADD_NEW_FLIGHT, (fare) => fare);
export const clearFare = createAction(CLEAR_FLIGHT);
